import React, { useEffect, useState } from "react";
import { Trash2, Plus, Hammer, SaveAll } from "lucide-react";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import toast from "react-hot-toast";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const Laborcost = ({
  workOrderDetail,
  labours,
  setLabours,
  serviceLabourCost,
  setServiceLabourCost,
  setActiveTab,
  creationType,
  getVehicleTaskDetails,
  handleImageOpen,
  setCreationType,
  getServiceLabourDetails,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");

  const [errors, setErrors] = useState({});

  console.log("labours", labours);

  const addRow = () => {
    setLabours([
      ...labours,
      {
        laborCount: "",
        serviceAmount: "",
        description: "",
        panelDetails: "",
        attachements: [],
        sgstAmount: "",
        cgstAmount: "",
        sgstPercentage: "",
        cgstPercentage: "",
        totalTax: "",
        totalTaxPercentage: "",
        totalTaxAmount: "",
        laborCost: "",
        totalCost: "",
        discountAmount: "",
        discountPercentage: "",
      },
    ]);
  };

  const parseImages = (value) => {
    try {
      if (!value) return [];

      // If already array → return as is
      if (Array.isArray(value)) return value;

      // If it's a string → parse it
      const parsed = typeof value === "string" ? JSON.parse(value) : value;

      // If parsed is array → return
      if (Array.isArray(parsed)) return parsed;

      // If it's a single object → wrap in array
      if (typeof parsed === "object") return [parsed];

      return [];
    } catch (e) {
      return [];
    }
  };

  function ccyFormat(num) {
    return `${Number(num || 0).toFixed(2)}`;
  }

  const removeRow = (index) => {
    const updated = labours.filter((_, i) => i !== index);
    setLabours(updated);
  };

  const validateStep1 = () => {
    let errors = {};

    if (!labours[0].description) errors.description = "Description is required";
    if (!labours[0].laborCount) errors.laborCount = "Labour Count is required";
    // if (!labours[0].attachements) errors.attachements = "Attachments is required";
    if (!labours[0].serviceAmount)
      errors.serviceAmount = "Service Amount is required";
    // if (!labours[0].laborCost) errors.laborCost = "Labor Cost is required";

    return errors;
  };

  const saveRow = async () => {
    const validationErrors = validateStep1();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error("Please fill all required fields");
      return;
    }

    setErrors({});

    let payload;

    if (creationType?.type === "new") {
      payload = {
        labourCount: labours[0].laborCount,
        serviceAmount: Number(labours[0].serviceAmount),
        description: labours[0].description,
        discountAmount: Number(labours[0]?.discountAmount || 0),
        discountPercentage: Number(labours[0]?.discountPercentage || 0),
        sgstAmount: labours[0].sgstAmount || 0,
        sgstPercentage: labours[0]?.sgstPercentage || 0,
        cgstAmount: labours[0].cgstAmount || 0,
        cgstPercentage: labours[0]?.cgstPercentage || 0,
        totalTaxPercentage: labours[0]?.totalTaxPercentage || 0,
        totalTax: Number(labours[0]?.totalTaxAmount || 0),
        totalTaxAmount: Number(labours[0]?.totalTaxAmount || 0),
        totalAmount: Number(labours[0]?.totalCost || 0),
        totalCost: Number(labours[0]?.totalCost || 0),
        // laborCost: Number(labours[0]?.laborCost || 0),
        // attachments: JSON.stringify(labours[0].attachements) || [],
        serviceLogId: workOrderDetail?.id,
      };
    } else {
      payload = {
        labourCount: labours[0].laborCount,
        serviceAmount: Number(labours[0].serviceAmount),
        description: labours[0].description,
        discountAmount: Number(labours[0]?.discountAmount || 0),
        discountPercentage: Number(labours[0]?.discountPercentage || 0),
        sgstAmount: labours[0].sgstAmount || 0,
        sgstPercentage: labours[0]?.sgstPercentage || 0,
        cgstAmount: labours[0].cgstAmount || 0,
        cgstPercentage: labours[0]?.cgstPercentage || 0,
        totalTaxPercentage: labours[0]?.totalTaxPercentage || 0,
        totalTax: Number(labours[0]?.totalTaxAmount || 0),
        totalTaxAmount: Number(labours[0]?.totalTaxAmount || 0),
        totalAmount: Number(labours[0]?.totalCost || 0),
        totalCost: Number(labours[0]?.totalCost || 0),
        // laborCost: Number(labours[0]?.laborCost || 0),
        // attachments: JSON.stringify(labours[0].attachements) || [],
        serviceLogId: workOrderDetail?.id,
        id: creationType?.id,
      };
    }

    console.log("PAYLOSD FOR LAOGOBBB", payload);
    // return

    toast.loading("Labor details adding... Please wait", {
          id: "upload", // same ID to update later
          position: "top-center",
        });

    try {
      const res = await fetch(`${apiUrl}/api/laborservices`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.dismiss("upload")
        toast.success("Vehicle Service Task Added Successfully 🎉");
        setLabours([
          {
            laborCount: "",
            serviceAmount: "",
            description: "",
            panelDetails: "",
            attachements: [],
            sgstAmount: "",
            cgstAmount: "",
            sgstPercentage: "",
            cgstPercentage: "",
            totalTax: "",
            totalTaxPercentage: "",
            totalTaxAmount: "",
            laborCost: "",
            totalCost: "",
            discountAmount: "",
            discountPercentage: "",
          },
        ]);
        setCreationType({
          type: "new",
          id: null,
        });
        // setActiveTab("summary");
        await getServiceLabourDetails(workOrderDetail?.id);
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const handleChange = (index, field, value) => {
    const updated = [...labours];
    const item = { ...updated[index], [field]: value };

    const laborCount = Number(item.laborCount || 0);
    const serviceAmount = Number(item.serviceAmount || 0);
    const effectiveServiceAmount = serviceAmount * (laborCount || 1);

    if (field === "discountAmount") {
      const discountAmount = Number(value || 0);
      item.discountPercentage = effectiveServiceAmount
        ? Number(((discountAmount / effectiveServiceAmount) * 100).toFixed(2))
        : "";
    }

    if (field === "discountPercentage") {
      const discountPercentage = Number(value || 0);
      item.discountAmount = effectiveServiceAmount
        ? Number(
            ((discountPercentage / 100) * effectiveServiceAmount).toFixed(2),
          )
        : "";
    }

    if (field === "serviceAmount" || field === "laborCount") {
      if (item.serviceAmount === "" || item.laborCount === "") {
        item.discountAmount = "";
        item.discountPercentage = "";
        item.cgstPercentage = "";
        item.sgstPercentage = "";
        item.totalTaxPercentage = "";
        item.totalTaxAmount = "";
        item.totalCost = "";
      } else {
        const discountAmount = Number(item.discountAmount || 0);
        const discountPercentage = Number(item.discountPercentage || 0);
        const totalServiceAmount = Number(item.serviceAmount || 0) * laborCount;

        if (discountPercentage) {
          item.discountAmount = Number(
            ((discountPercentage / 100) * totalServiceAmount).toFixed(2),
          );
        } else if (discountAmount) {
          item.discountPercentage = totalServiceAmount
            ? Number(((discountAmount / totalServiceAmount) * 100).toFixed(2))
            : "";
        }
      }
    }

    if (field === "laborCount" && value === "") {
      item.discountAmount = "";
      item.discountPercentage = "";
      item.cgstPercentage = "";
      item.sgstPercentage = "";
      item.totalTaxPercentage = "";
      item.totalTaxAmount = "";
      item.totalCost = "";
    }

    updated[index] = item;
    setLabours(updated);
  };

  const handleFileChange = async (index, files) => {
    toast.loading("Image Upload Processing... Please wait", {
      id: "upload", // same ID to update later
      position: "bottom-center",
    });
    const res = await uploadmutiplefile(files, "vehicles", "vehicle");
    toast.dismiss("upload");
    const uploaded = res?.uploaded || [];

    setLabours((prev) => {
      const updated = [...prev];

      updated[index].attachements = [
        ...(updated[index].attachements || []),
        ...uploaded,
      ];

      return updated;
    });
  };

  const getFileType = (url = "") => {
    const ext = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
    if (["mp4", "webm", "ogg"].includes(ext)) return "video";
    if (["pdf"].includes(ext)) return "pdf";
    if (["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(ext))
      return "doc";

    return "other";
  };

  useEffect(() => {
    setLabours((prev) => {
      if (!prev.length) return prev;
      const updated = [...prev];
      const current = { ...updated[0] };
      const cgst = Number(current.cgstPercentage || 0);
      const sgst = Number(current.sgstPercentage || 0);
      const explicitTotalTax = Number(
        current.totalTaxPercentage || current.totalTax || 0,
      );
      const computedTotalTaxPercentage = cgst + sgst;
      const totalTaxPercentage = computedTotalTaxPercentage || explicitTotalTax;
      current.totalTaxPercentage = totalTaxPercentage;

      const serviceAmount = Number(current.serviceAmount || 0);
      const laborCount = Number(current.laborCount || 0);
      const laborCost = Number(current.laborCost || 0);
      const totalServiceAmount = serviceAmount * laborCount;
      const shouldClear = !totalServiceAmount || !laborCount;

      if (shouldClear) {
        current.cgstPercentage = "";
        current.sgstPercentage = "";
        current.cgstAmount = "";
        current.sgstAmount = "";
        current.totalTaxPercentage = "";
        current.totalTaxAmount = "";
        current.totalCost = "";
        current.discountAmount = "";
        current.discountPercentage = "";
        updated[0] = current;
        return updated;
      }

      let discountAmount = Number(current.discountAmount || 0);

      if (discountAmount > totalServiceAmount) {
        discountAmount = totalServiceAmount;
        current.discountAmount = Number(discountAmount.toFixed(2));
      }

      const taxableBase = totalServiceAmount - discountAmount + laborCost;
      const totalTaxAmount = isFinite(taxableBase)
        ? (taxableBase * totalTaxPercentage) / 100
        : 0;
      current.totalTaxAmount = Number(totalTaxAmount.toFixed(2));
      current.totalCost = Number((taxableBase + totalTaxAmount).toFixed(2));
      updated[0] = current;
      return updated;
    });
  }, [
    labours[0]?.sgstPercentage,
    labours[0]?.cgstPercentage,
    labours[0]?.serviceAmount,
    labours[0]?.laborCost,
    labours[0]?.totalTaxPercentage,
    labours[0]?.totalTax,
    labours[0]?.discountAmount,
  ]);

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold text-slate-800 flex items-center gap-2">
          <Hammer className="text-blue-600 w-5 h-5" />
          Service Labours
        </h2>

        <button
          type="button"
          onClick={addRow}
          disabled={labours.length >= 1}
          className="text-sm bg-blue-600 text-white px-3 py-1.5 rounded-lg hover:bg-blue-700 transition flex items-center gap-1"
        >
          <Plus size={16} />
          Add Labour
        </button>
      </div>

      <div className="space-y-3">
        {labours.map((task, index) => (
          <div
            key={index}
            className="grid grid-cols-12 gap-3 items-center bg-gray-200 p-3 rounded-lg border border-gray-100"
          >
            <div className="col-span-2">
              <input
                type="number"
                placeholder="Labor Count"
                className="w-full border rounded-md p-2 text-sm"
                value={task.laborCount}
                onChange={(e) =>
                  handleChange(index, "laborCount", e.target.value)
                }
              />
            </div>

            <div className="col-span-2">
              <input
                type="number"
                placeholder="Service Amount"
                className="w-full border rounded-md p-2 text-sm"
                value={task.serviceAmount}
                onChange={(e) =>
                  handleChange(index, "serviceAmount", e.target.value)
                }
              />
            </div>

            <div className="col-span-2">
              <input
                type="text"
                placeholder="description"
                className="w-full border rounded-md p-2 text-sm"
                value={task.description}
                onChange={(e) =>
                  handleChange(index, "description", e.target.value)
                }
              />
            </div>

            <div className="col-span-2">
              <input
                type="number"
                placeholder="Discount Amount"
                className="w-full border rounded-md p-2 text-sm"
                value={task.discountAmount}
                onChange={(e) =>
                  handleChange(index, "discountAmount", e.target.value)
                }
              />
            </div>

            <div className="col-span-2">
              <input
                type="number"
                placeholder="Discount Percentage"
                className="w-full border rounded-md p-2 text-sm"
                value={task.discountPercentage}
                onChange={(e) =>
                  handleChange(index, "discountPercentage", e.target.value)
                }
              />
            </div>

            <div className="col-span-2">
              <input
                type="number"
                placeholder="Total Amount"
                className="w-full border rounded-md p-2 text-sm"
                value={task.totalCost}
                disabled
              />
            </div>

            {/* <div className="col-span-2">
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-1 text-center hover:border-blue-500 transition">
                <input
                  type="file"
                  multiple
                  // accept="image/*"
                  className="hidden"
                  id={`file-${index}`}
                  onChange={(e) => handleFileChange(index, e.target.files)}
                />

                <label
                  htmlFor={`file-${index}`}
                  className="cursor-pointer text-sm text-blue-600"
                >
                  Click to upload Attachments
                </label>
              </div>
              <div className="flex gap-2 mt-2 flex-wrap">
                {task.attachements?.map((file, i) => (
                  <div key={i} className="relative">
                    <img
                      src={file.url || file?.path || file?.Location || file}
                      alt="preview"
                      onClick={() => {
                        handleImageOpen(
                          file.url || file?.path || file?.Location || file,
                        );
                      }}
                      className="w-4 h-4 object-cover rounded-md border"
                    />                 
                  </div>
                ))}
              </div>
            </div> */}

            <div className="col-span-12">
              <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h3 className="text-sm font-semibold text-gray-800">
                      Tax Details
                    </h3>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                  {/* CGST */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      CGST (%)
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        placeholder="0"
                        value={task.cgstPercentage}
                        onChange={(e) =>
                          handleChange(index, "cgstPercentage", e.target.value)
                        }
                        className="w-full h-11 border border-gray-300 rounded-lg pl-3 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                        %
                      </span>
                    </div>
                  </div>

                  {/* SGST */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      SGST (%)
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        placeholder="0"
                        value={task.sgstPercentage}
                        onChange={(e) =>
                          handleChange(index, "sgstPercentage", e.target.value)
                        }
                        className="w-full h-11 border border-gray-300 rounded-lg pl-3 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                        %
                      </span>
                    </div>
                  </div>

                  {/* Total Tax */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Total Tax (%)
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        placeholder="0"
                        value={task.totalTaxPercentage ?? ""}
                        onChange={(e) =>
                          handleChange(
                            index,
                            "totalTaxPercentage",
                            e.target.value,
                          )
                        }
                        className="w-full h-11 border border-gray-300 rounded-lg pl-3 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                        %
                      </span>
                    </div>
                  </div>

                  {/* Tax Amount */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Tax Amount (₹)
                    </label>
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                        ₹
                      </span>
                      <input
                        type="number"
                        value={task.totalTaxAmount ?? ""}
                        onChange={(e) =>
                          handleChange(index, "totalTaxAmount", e.target.value)
                        }
                        className="w-full h-11 border border-gray-300 rounded-lg pl-8 pr-3 text-sm bg-green-50 font-medium"
                      />
                    </div>
                  </div>
                </div>

                {/* Summary */}
                <div className="mt-4 flex justify-end">
                  <div className="bg-gray-50 border rounded-lg px-4 py-2">
                    <span className="text-xs text-gray-500">GST Rate</span>
                    <div className="text-lg font-semibold text-blue-600">
                      {task.totalTaxPercentage || 0}%
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-span-1 text-center">
              <div className="flex gap-4">
                <button
                  type="button"
                  title="Delete"
                  onClick={() => removeRow(index)}
                  className="text-red-500 hover:text-red-700"
                >
                  <Trash2 size={24} />
                </button>
                <button
                  type="button"
                  title="Save"
                  onClick={() => saveRow(index)}
                  className="text-green-500 hover:text-green-700"
                >
                  <SaveAll size={24} />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="col-span-12 md:col-span-12 bg-white shadow-lg rounded-2xl p-6 h-full mt-4">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">
          Service Labour Cost
        </h2>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700, borderRadius: 10 }}>
            <TableHead>
              <TableRow>
                <TableCell>Labor Count</TableCell>
                <TableCell>Service Amount</TableCell>
                <TableCell>Description</TableCell>
                <TableCell align="right">Discount Amount</TableCell>
                <TableCell align="right">Discount Percentage</TableCell>
                <TableCell>CGST Percentage</TableCell>
                <TableCell align="right">SGST Percentage</TableCell>
                <TableCell align="right">Total Tax Percentage</TableCell>
                <TableCell align="right">Total Tax Amount</TableCell>
                <TableCell align="right">Total Amount</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {serviceLabourCost?.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.labourCount || "-"}</TableCell>
                  <TableCell>{row.serviceAmount || "-"}</TableCell>
                  <TableCell>{row.description || "-"}</TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.discountAmount)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.discountPercentage)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.cgstPercentage)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.sgstPercentage)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.totalTaxPercentage)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.totalTaxAmount)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.totalAmount)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default Laborcost;
